import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { CEPServices } from '../../../services/cep.service';
import { AddressService } from '../../../services/address.service';
import  brazilStates from '../../../../assets/shared/data/brazilStates.json';
import { ICompany } from '../../../interfaces/company/company';


@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  providers: [ RequestsServices, StorageService, UserService, CEPServices, AddressService ],
  encapsulation: ViewEncapsulation.None
})
export class AddressesComponent extends PageBase implements OnInit {

  company: ICompany = {addresses: []} as ICompany;
  addressErros = [];
  isShowError = false;
  isLoading;
  statesList = brazilStates.list;

  constructor(
    private translate: TranslateService,
    private toasterService: ToasterService,
    private request: RequestsServices,
    private userService: UserService,
    public cepService: CEPServices,
    public addressService: AddressService
  ) {
    super();
    const languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);

    const companyAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    if (typeBusiness === 'company' && companyAccount) {
      this.getCompany(companyAccount['id']);
    } else {
      alert('Conta de empresa inválida');
    }
  }

  private addressToGeopoint(address, index): any {
    let addressAsString = '';
    if (address.street) {
      addressAsString += address.street;
    }

    if (address.number) {
      addressAsString += ', ' + address.number;
    }

    if (address.neighborhood) {
      addressAsString += ', ' + address.neighborhood;
    }

    if (address.county) {
      addressAsString += ', ' + address.county;
    }

    if (address.state) {
      addressAsString += ', ' + address.state;
    }

    if (address.cep) {
      addressAsString += ', ' + address.cep;
    }

    const requestGeopoint = this.addressService.addressToGeoPoint(addressAsString);

    return requestGeopoint;
  }

  private getCompany(companyId): void {
    this.isLoading = true;
    this.request.get({path: 'companies', pathParam: `/${companyId}?filter[include]=addresses`}).then((company) => {
      this.isLoading = false;
      this.company = company;
      this.company.addresses = this.formatStateAddress(company.addresses);
      this.isShowError = !this.validateAddress(this.company.addresses, false);
      this.addressErros = this.checkAddressErros(this.company.addresses);
    });
  }

  private formatStateAddress(addresses) {
    return addresses.map(address => {
      address.state = this.statesList.filter(state => state.id === address.state);
      return address;
    })
  }

  public cepChange(value: any, index: number): void {
    let getCep = value.currentTarget.value;
    if (!getCep) {
      return;
    }

    getCep = getCep.replace(/_/g, '');

    if (getCep.length === 9) {
      this.isLoading = true;
      this.cepService.getAddressByCep(getCep).subscribe((place) => {

        const state = this.statesList.find(el => el.id === place.uf);

        this.isLoading = false;
        // TODO: Use address interface -> this.company.addresses
        this.company['addresses'][index].neighborhood = place.bairro;
        this.company['addresses'][index].county = place.localidade;
        this.company['addresses'][index].state = state ? [state] : '';
        this.company['addresses'][index].street = place.logradouro;
        this.addressErros = this.checkAddressErros(this.company['addresses']);
      });
    }
  }

  public normalizeData(address) {
    let state;
    if (address.state) {
      state = (typeof address.state === 'string') ? address.state : address.state[0].id;
    } else {
      state = '';
    }
    const addressData = {
      ...address,
      companyId: this.company.id,
      state
    };
    delete addressData.isOpenAccordion;
    delete addressData.index;
    delete addressData.name;
    return addressData;
  }

  public showErros(): void {
    this.isShowError = true;
    // TODO: Use address interface -> this.company.addresses
    this.addressErros = this.checkAddressErros(this.company['addresses']);
  }

  public addAddress(): void {
    this.isShowError = false;
    // TODO: Use address interface -> this.company.addresses
    this.addressErros = this.checkAddressErros(this.company['addresses']);

    if (!this.validateAddress(this.company['addresses'], false)) {
      this.isShowError = true;
      return;
    }

    // Closse all others accordions addresses
    // TODO: Use address interface -> this.company.addresses
    for (let address of this.company['addresses']) {
      address.isOpenAccordion = false;
    }
    // TODO: Use address interface -> this.company.addresses
    let calcLength = this.company['addresses'].length + 1;
    this.company['addresses'].push({
      index: calcLength - 1,
      isOpenAccordion: true,
      name: 'Endereço ' + calcLength,
      nameUnit: null,
      cep: null,
      neighborhood: null,
      county: null,
      state: null,
      street: null,
      number: null,
      additional: null,
      telephone: null,
      location: {lat: 0, lng: 0}
    });
  }

  private removeAddress(index: number): void {
    // TODO: Use address interface -> this.company.addresses
    const addressId = this.company['addresses'][index]['id'] || null;

    if (addressId) {
      // Delete request
      this.isLoading = true;
      this.request.delete('company_addresses', '', `/${addressId}`).then((company) => {
        this.isLoading = false;

        this.getCompany(this.company['id']);

        this.toasterService.info('Sucesso', 'Endereço atualizado com sucesso.', true, 2000);
        this.userService.requestAccountConfig();
      });
    } else {
      this.company['addresses'].splice(index, 1);
    }
  }

  private updateAddressErros(): void {
    // TODO: Use address interface -> this.company.addresses
    this.addressErros = this.checkAddressErros(this.company['addresses']);
  }


  public updateAddress(i): void {
    // TODO: Use address interface -> this.company.addresses
    this.addressErros = this.checkAddressErros(this.company['addresses']);

    if (!this.validateAddress(this.company.addresses, false, 0)) {
      this.toasterService.info('Atenção', 'Preencha pelo menos 1 endereço.', false, 4000);
      this.showErros();
      return;
    } else {
      // TODO: Use address interface -> this.company.addresses
      if (!this.validateAddress(this.company['addresses'], false)) {
        this.isShowError = true;
        return;
      }

      let addressData = this.normalizeData(this.company.addresses[i]);

      this.isLoading = true;
      this.addressToGeopoint(addressData, i).then((geolocation) => {
        this.isLoading = false;

        if (geolocation && geolocation.lat && geolocation.lng) {
          addressData = {...addressData, location: {lat: geolocation.lat, lng: geolocation.lng}};
        } else {
          addressData = {...addressData, location: {lat: 0, lng: 0}};
        }
        this.saveRequest(addressData);
      });
    }

  }


  private saveRequest(addressesData): void {
      if (addressesData && addressesData['id']) {
        this.isLoading = true;
        this.request.patch('company_addresses', addressesData).then((company) => {
          this.isLoading = false;
          if (company) {
            this.getCompany(this.company['id']);
            this.toasterService.info('Sucesso', 'Endereço salvo com sucesso.', true, 2000);
            this.userService.requestAccountConfig();
          }
        });
      } else {
        this.isLoading = true;
        this.request.post('company_addresses', addressesData).then((company) => {
          this.isLoading = false;
          if (company) {
            this.getCompany(this.company['id']);
            this.toasterService.info('Sucesso', 'Endereço salvo com sucesso.', true, 2000);
            this.userService.requestAccountConfig();
          }
        });
      }
  }

}
